<template>
  <div class="activity-box">
    <img src="./images/bg.jpg" alt="" />
    <img src="./images/bg2.jpg" alt="" />
  </div>
</template>
<script>
export default {
  name: 'Constellation',
  data() {
    return {};
  }
};
</script>
<style lang="scss" scoped>
.activity-box {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
  background-color: #160f3a;
  img {
    width: 1px;
    height: 100%;
    flex: auto;
    object-fit: contain;
  }
}
</style>
